// extracted by mini-css-extract-plugin
module.exports = {"hero-banner-link":"HeroBannerLink_hero-banner-link__DGIw0","hero-banner-link__item":"HeroBannerLink_hero-banner-link__item__49dEt"};